'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M16 10h-2v2h2v-2zm0 4h-2v2h2v-2zm-8-4H6v2h2v-2zm4 0h-2v2h2v-2zm8-6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z' });

var ImageAspectRatio = function ImageAspectRatio(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

ImageAspectRatio = (0, _pure2.default)(ImageAspectRatio);
ImageAspectRatio.muiName = 'SvgIcon';

exports.default = ImageAspectRatio;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/ImageAspectRatio.js
// module id = 2499
// module chunks = 0